// Locale-aware wrapper around react-router-dom.
// A Vite resolver (vite.config.ts) points every `import ... from "react-router-dom"`
// in app code at this module, so ALL <Link>/<NavLink> internal paths automatically
// keep the current URL's language prefix (/es/..., /ar/...). Query strings and
// fragments are preserved. External, mailto:, tel:, relative and already-prefixed
// paths are left untouched. Pass `data-no-localize` to opt out.
// eslint-disable-next-line no-restricted-imports
import * as RR from "react-router-dom/dist/index.js";
import { forwardRef } from "react";
import { localeFromPath, isLocale, withLocale } from "@/i18n/config";

export * from "react-router-dom/dist/index.js";

const FILE_RE = /\.[a-z0-9]{2,5}$/i;

export function localizeTo(to: any, pathname: string): any {
  const locale = localeFromPath(pathname);
  if (locale === "en") return to;
  const fix = (p: string) => {
    if (!p.startsWith("/") || p.startsWith("//")) return p;
    const m = p.match(/^([^?#]*)(.*)$/)!;
    const path = m[1] || "/";
    if (isLocale(path.split("/")[1])) return p;
    if (FILE_RE.test(path) || path.startsWith("/admin") || path.startsWith("/login") || path.startsWith("/~")) return p;
    return withLocale(path, locale) + m[2];
  };
  if (typeof to === "string") return fix(to);
  if (to && typeof to === "object" && typeof to.pathname === "string") return { ...to, pathname: fix(to.pathname) };
  return to;
}

export const Link = forwardRef<HTMLAnchorElement, any>(function Link({ to, ...rest }, ref) {
  const { pathname } = RR.useLocation();
  const skip = rest["data-no-localize"] !== undefined;
  return <RR.Link ref={ref} to={skip ? to : localizeTo(to, pathname)} {...rest} />;
});

export const NavLink = forwardRef<HTMLAnchorElement, any>(function NavLink({ to, ...rest }, ref) {
  const { pathname } = RR.useLocation();
  const skip = rest["data-no-localize"] !== undefined;
  return <RR.NavLink ref={ref} to={skip ? to : localizeTo(to, pathname)} {...rest} />;
});
